import { Box, Typography } from "@mui/material"

const NormalCard = ({ item, size = "normal" }) => {
  return (
    <Box>
      <Box
        sx={{
          display: "inline-flex",
          alignContent: "center",
          p: size === "normal" ? 1 : 0.5,
          borderRadius: "8px",
          backgroundColor: size === "normal" ? "#fff" : "bg.light",
        }}
      >
        <Typography variant={size === "normal" ? "body2" : "caption"} sx={{ fontWeight: 500 }}>
          {item.name}
        </Typography>
      </Box>
    </Box>
  )
}

export default NormalCard
